import { useEffect, useState } from "react";
import Staff from "../../../actions/staff";

import Controls from "../../../components/controls/Controls";
import { Form } from "../../../components/customHelpers/useForm";
import Order from "../../../actions/order";
import {
  FormControl,
  Select as MuiSelect,
  Grid,
  InputLabel,
  MenuItem,
  Box,
  Typography,
  FormHelperText,
} from "@mui/material";

const Assigntff = ({
  NotifyMessage,
  setOpenPopup,
  id,
  getAllOrders,
  handleStatusChange,
  event,
  type,
}) => {
  const { viewStoreKeepers, viewAllStaff } = Staff();
  const { OrderAssigned } = Order();
  const [staff, setStaffs] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [roleError, setRoleError] = useState(false);
  const [selectedStaffId, setSelectedStaffId] = useState("");

  useEffect(() => {
    getAllStaffs();
  }, []);

  const getAllStaffs = () => {
    if (handleStatusChange) {
      viewStoreKeepers().then((data) => {
        if (data.err) {
          NotifyMessage({
            message: data.err,
            type: "error",
          });
        } else if (data.staffs) {
          setStaffs((prevStaffs) => [...prevStaffs, ...data.staffs]);
        }
      });
    } else {
      viewAllStaff().then((data) => {
        if (data.err) {
          NotifyMessage({
            message: data.err,
            type: "error",
          });
        } else if (data.staffs) {
          setStaffs(data.staffs);
        }
      });
    }
  };

  const handleChange = (event) => {
    const staffId = event.target.value;
    const selectedStaffObj = staff.find((s) => s.id === staffId);
    setSelectedStaffId(staffId);
    setSelectedStaff(selectedStaffObj || null);
  };

  const handleSubmit = () => {
    if (!selectedStaff) {
      setRoleError(true);
      return;
    }

    const user = {
      fullName: selectedStaff.fullName,
      type: type,
    };

    if (handleStatusChange !== null) {
      handleStatusChange(event);
    }

    OrderAssigned({ user, id: selectedStaff.id }, id).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.order) {
        NotifyMessage({
          message: "Order Assigned",
          type: "success",
        });
        setOpenPopup(false);
        getAllOrders();
      }
    });
  };

  const handleAddClick = (e) => {
    e.preventDefault();
    handleSubmit();
  };

  return (
    <Form onSubmit={handleAddClick}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <FormControl
            variant="outlined"
            fullWidth
            {...(roleError && { error: true })}
          >
            <InputLabel>Select User</InputLabel>
            <MuiSelect
              label="Select User"
              name="staff"
              value={selectedStaffId}
              onChange={handleChange}
            >
              {staff.map((staffMember) => (
                <MenuItem key={staffMember.id} value={staffMember.id}>
                  {staffMember.fullName}
                </MenuItem>
              ))}
            </MuiSelect>
            {roleError && (
              <FormHelperText error>Please select one User</FormHelperText>
            )}
          </FormControl>
        </Grid>

        {selectedStaff && (
          <Grid item xs={12} md={6}>
            <Box mt={2}>
              <Typography variant="body1">
                <strong>Phone Number:</strong> {selectedStaff.phoneNo}
              </Typography>
              <Typography variant="body1">
                <strong>Role:</strong>{" "}
                {selectedStaff.staffRoles && selectedStaff.staffRoles.length > 0
                  ? selectedStaff.staffRoles[0].role.name
                  : selectedStaff.role}
              </Typography>
            </Box>
          </Grid>
        )}
        {!selectedStaff && <Grid item xs={12} md={6} />}

        <Grid item xs={12} md={6}>
          <div>
            <Controls.Button text={"Assign"} type="submit" />
            <Controls.Button
              text={"Cancel"}
              color="default"
              onClick={() => {
                setOpenPopup(false);
              }}
            />
          </div>
        </Grid>
      </Grid>
    </Form>
  );
};

export default Assigntff;
